import { SiteSectionIds } from '../../../../contentful';
import { SiteSectionSlug } from '../../../../types/siteSectionSlug';

const siteSectionIdToSlugMap: {
	[key in SiteSectionIds]?: SiteSectionSlug;
} = {
	[SiteSectionIds.MCO]: SiteSectionSlug.MCO,
	[SiteSectionIds.ORL]: SiteSectionSlug.ORL,
	[SiteSectionIds.BUSINESS]: SiteSectionSlug.BUSINESS,
	[SiteSectionIds.MCOCARES]: SiteSectionSlug.MCOCARES,
};

const siteSectionSlugToIdMap: {
	[key in SiteSectionSlug]?: SiteSectionIds;
} = {
	[SiteSectionSlug.MCO]: SiteSectionIds.MCO,
	[SiteSectionSlug.ORL]: SiteSectionIds.ORL,
	[SiteSectionSlug.BUSINESS]: SiteSectionIds.BUSINESS,
	[SiteSectionSlug.MCOCARES]: SiteSectionIds.MCOCARES,
};

export const getCurrentSiteSectionSlug = (
	id?: string | SiteSectionIds,
): SiteSectionSlug =>
	siteSectionIdToSlugMap[id as SiteSectionIds] ||
	siteSectionIdToSlugMap[SiteSectionIds.MCO]!;

export const getCurrentSiteSectionId = (url: string) => {
	const siteSectionSlug = getCurrenWebsiteSlugFromUrl(url);

	return siteSectionSlugToIdMap[siteSectionSlug];
};

export const getCurrenWebsiteSlugFromUrl = (url: string) => {
	const parts = url.split('/');
	const siteSectionSlug = parts[1]?.toLowerCase();

	return siteSectionSlug as SiteSectionSlug;
};
